import {React, observer} from '@api'
import {IJsonTabNode, TabNode, TabSetNode} from '@flexlayout'
import {ContextMenuItem, ContextMenuItemProps, IFlexLayoutWhiteboardTabConfig, NewFlexLayoutTabMenuItemProps, useStores} from '@modules'
import {createWhiteboardTab, WhiteboardFlexLayoutTabStore} from '@modules/whiteboard/WhiteboardFlexLayoutTab'
import {icons} from '@stores'

/// region Components

type MyProps = NewFlexLayoutTabMenuItemProps & {
  className?: string
}

export const NewWhiteboardTabMenuItem = observer<MyProps>(function NewWhiteboardTabMenuItem({className, action, tab, tabSet, ...rest}) {
  const {deployments: {deploymentConfig: {settings}}} = useStores()

  if (!settings?.whiteboard && !DEBUG) return null
  return (
      <ContextMenuItem
        {...rest}
        shouldDismissPopover
        icon={icons.whiteboard}
        text={`Whiteboard`}
        //active={tab?.component === 'vipBuying' && ((tab.config as IFlexLayoutIFrameTabConfig)?.settings?.url === BuyingBoardUrl.retail)}
        onClick={() => {
          createWhiteboardTab({tab, tabSet})
        }}
      />)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/NewWhiteboardTabMenuItem.tsx